import { render, staticRenderFns } from "./ListDetailMemberData.vue?vue&type=template&id=72985c94&scoped=true&"
import script from "./ListDetailMemberData.vue?vue&type=script&lang=js&"
export * from "./ListDetailMemberData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72985c94",
  null
  
)

export default component.exports